<template>
  <div>
    <Modals v-if="modules.regular" />
    <UserModals v-if="modules.user" />
  </div>
</template>

<script>
import { bus } from '@/main';
import { USER_MODALS_ALLOWED_NAMES } from '@/helpers/modals-user';

const modalToOpenAttributes = {
  name: null,
  params: null,
};

const componentImportCallback = (webpackModule) => {
  setTimeout(() => {
    bus.$emit('open-modal', modalToOpenAttributes.name, modalToOpenAttributes.params);
  });

  return webpackModule;
};

export default {
  name: 'AppModals',
  components: {
    Modals: () =>
      import(/* webpackChunkName: "modals" */ '../app/shared/components/Modals/Modals.vue').then(
        componentImportCallback,
      ),
    UserModals: () =>
      import(
        /* webpackChunkName: "user-modals" */ '../app/shared/components/Modals/UserModals.vue'
      ).then(componentImportCallback),
  },
  data() {
    return {
      unwatchQueryParameter: null,
      modules: {
        regular: false,
        user: false,
      },
    };
  },
  created() {
    bus.$on('open-modal', this.loadModalChunks);
    this.unwatchQueryParameter = this.$watch('$route.query.modal', (value) => {
      if (this.$route.query.modal != 'registration-lp') {
        // todo: make sure that it is working properly when jl_source query param exists
        this.loadModalChunks(value);
      }
    });
  },
  methods: {
    getModule(modalName) {
      return USER_MODALS_ALLOWED_NAMES.includes(modalName) ? 'user' : 'regular';
    },
    loadModalChunks(name, params) {
      const module = this.getModule(name);

      if (this.modules[module]) {
        return;
      }

      modalToOpenAttributes.name = name;
      modalToOpenAttributes.params = params;
      this.modules[module] = true;

      if (Object.values(this.modules).every(Boolean)) {
        bus.$off('open-modal', this.loadModalChunks);
        this.unwatchQueryParameter();
      }
    },
  },
};
</script>
